import React from "react";
import Collapse from '../components/Collapse/Collapse';
import data from "../data/content";

const Faq = () => {
  const { title, items, imageUrl } = data.faq;
  return (
    <section
      className="flex md:flex-col items-center bg-darkGreen-100 !py-0"
      id="faq"
      style={{scrollMarginTop: 70}}
    >
      <div className="flex flex-col md:flex-row p-0 md:p-6 lg:max-w-[80%] mx-auto space-6">
        <div className="flex items-start md:pt-20 pt-0 mx-auto md:w-2/5 bg-inherit">
          <img
            src={imageUrl}
            alt=""
            className="w-full h-auto md:rounded-[40px] rounded-none pb-0"
          />
        </div>
        <div className="flex flex-col md:w-3/5 p-10 lg:pt-10">
          <span className="text-lemonGreen-100 text-lg font-extrabold">
            Preguntas frecuentes
          </span>
          <br />
          <span className="text-white text-2xl font-bold mb-3">
            {title}
          </span>
          <br />
          <hr className="w-32 bg-lemonGreen-100 h-1 mb-8" />
          <Collapse items={items}/>
          <div className="md:mb-16">&nbsp;</div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
